import { EventBus } from "../../../../util/event/EventBus";
import { EventObject } from "../../../../util/event/EventObject";
import { Logger } from "../../../../util/log/Logger";
import { AppCore } from "../../../core/AppCore";
import { CurrencyType } from "../../controller/net/constant/Constants";
/**
 * BalanceManager.ts
 */
export class BalanceManager {
    constructor() {
        if (BalanceManager.instance) {
            throw new Error("Balance Manager Singleton Already Initialised");
        }
        BalanceManager.instance = this;
        this.create();
    }
    create() {
        this.core = AppCore.getInstance();
        this.eventBus = new EventBus();
        this.resetBalances();
        this.resetWin();
    }
    resetBalances() {
        this.cashBalance = this.bonusBalance = this.totalBalance = 0;
    }
    resetWin() {
        this.totalWin = 0;
    }
    addWin(value) {
        this.totalWin += value;
        this.dispatchBalanceUpdated();
    }
    setTotalWin(value, dispatch = false) {
        this.totalWin = value >= 0 ? value : 0;
        this.dispatchBalanceUpdated();
    }
    setBalance(data) {
        this.balanceData = data;
        this.updateActiveBalanceType();
        this.setCurrentBalance();
        this.setWinProcessorRsp();
    }
    setTitanBalance(cash, bonus, total, postWager, activeBalance) {
        this.resetBalances();
        this.cashBalance = cash;
        this.bonusBalance = bonus;
        this.totalBalance = total;
        if (postWager) {
            if (!this.previousBalanceType) {
                this.previousBalanceType = activeBalance;
            }
            this.handlePostWager(activeBalance);
        }
        this.dispatchBalanceUpdated();
    }
    updateActiveBalanceType() {
        let activeBalance = this.balanceData.getActiveBalanceType();
        if (!this.previousBalanceType) {
            this.previousBalanceType = activeBalance;
        }
        if (this.balanceData.isPostWager()) {
            this.handlePostWager(activeBalance);
        }
    }
    updateActiveBalanceTypeFromClientData(clientData) {
        let activeBalance = clientData.getActiveBalanceType();
        Logger.debug("Updating active balance from client data to: " + activeBalance);
        if (!this.previousBalanceType) {
            this.previousBalanceType = activeBalance;
            if (activeBalance === CurrencyType.BONUS) {
                this.dispatch(CMAWagerEvent.WAGER_BONUS);
            }
        }
        if (clientData.isPostWager()) {
            this.handlePostWager(activeBalance);
        }
    }
    handlePostWager(activeBalance) {
        if (this.previousBalanceType && this.previousBalanceType !== activeBalance) {
            if (activeBalance === CurrencyType.CASH) {
                this.dispatch(CMAWagerEvent.WAGER_CASH);
            }
            else if (activeBalance === CurrencyType.BONUS) {
                this.dispatch(CMAWagerEvent.WAGER_BONUS);
            }
        }
        this.previousBalanceType = activeBalance;
    }
    setCurrentBalance() {
        this.resetBalances();
        for (let balance of this.balanceData.getBalances()) {
            this.cashBalance += balance.getAmount();
        }
        for (let balance of this.balanceData.getBonusBalances()) {
            this.bonusBalance += balance.getAmount();
        }
    }
    setWinProcessorRsp() {
        this.winProcessorRsp = this.balanceData.getWinProcessorRsp();
        if (this.winProcessorRsp > 0) {
            this.dispatchWinProcessorRsp();
        }
    }
    getTotalBalance() {
        return this.cashBalance + this.bonusBalance;
    }
    getMaskedBalance() {
        return this.totalBalance - this.totalWin;
    }
    getTotalWin() {
        return this.totalWin;
    }
    getCashBalance() {
        return this.cashBalance;
    }
    getBonusBalance() {
        return this.bonusBalance;
    }
    getWinProcessorRsp() {
        return this.winProcessorRsp;
    }
    getCurrency() {
        if (this.balanceData) {
            return this.balanceData.getCurrencyCode();
        }
        return null;
    }
    setCashBalance(value) {
        this.cashBalance = value;
    }
    setBonusBalance(value) {
        this.bonusBalance = value;
    }
    addEventListener(type, handler, scope) {
        this.eventBus.addEventListener(type, handler, scope);
    }
    removeEventListener(type, scope) {
        this.eventBus.removeEventListener(type, scope);
    }
    dispatch(event) {
        this.core.dispatchEvent(event);
    }
    dispatchBalanceUpdated() {
        this.eventBus.dispatchEvent(new EventObject(BalanceEvent.UPDATED));
    }
    dispatchWinProcessorRsp() {
        this.eventBus.dispatchEvent(new EventObject(BalanceEvent.WIN_PROCESSOR_RSP));
    }
    static getInstance() {
        if (BalanceManager.instance === null) {
            BalanceManager.instance = new BalanceManager();
        }
        return BalanceManager.instance;
    }
}
BalanceManager.instance = null;
/**
 * CMAWagerEvent.ts
 */
export class CMAWagerEvent {
}
CMAWagerEvent.WAGER_CASH = new EventObject("CMAWagerEvent.WAGER_CASH");
CMAWagerEvent.WAGER_BONUS = new EventObject("CMAWagerEvent.WAGER_BONUS");
/**
 * BalanceEvent.ts
 */
export class BalanceEvent {
}
BalanceEvent.UPDATED = "BalanceEvent.UPDATED";
BalanceEvent.WIN_PROCESSOR_RSP = "BalanceEvent.WIN_PROCESSOR_RSP";
//# sourceMappingURL=BalanceManager.js.map